import axios from 'axios'
import baseUrl from './apiPath'

var ajax = axios.create({
    baseURL: baseUrl(),
    timeout: 10000
});

ajax.interceptors.request.use(config => config,error => Promise.reject(error))

ajax.interceptors.response.use(response=>response['data'],error => Promise.reject(error))

export default function install(_Vue) {
    _Vue.prototype.$ajax = ajax
}



// WEBPACK FOOTER //
// ./src/api/ajax.js